{
  "MACROS": {
    "HEADER": "Makrók",
    "DESCRIPTION": "A makró mentett műveletek sorozata, amely segít az ügyfélszolgálati ügynököknek a feladatok egyszerű elvégzésében. Az ügynökök műveleteket határozhatnak meg, például címke hozzáadása egy beszélgetéshez, e-mail-átirat küldése vagy egyéni attribútum frissítése, és ezeket egyetlen kattintással futtathatják.",
    "LEARN_MORE": "További információ a makrókról",
    "HEADER_BTN_TXT": "Új makró hozzáadása",
    "HEADER_BTN_TXT_SAVE": "Makró mentése",
    "LOADING": "Makrók lekérdezése",
    "ERROR": "Valami elromlott, kérjük töltsd próbáld újra",
    "ORDER_INFO": "A makrók a műveletek hozzáadásának sorrendjében fognak futni. A makrókat áthúzással át tudod rendezni.",
    "ADD": {
      "FORM": {
        "NAME": {
          "LABEL": "Makró neve",
          "PLACEHOLDER": "Írd ide a makród nevét",
          "ERROR": "Név megadása szükséges a makró létrehozásához"
        },
        "ACTIONS": {
          "LABEL": "Műveletek"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Makró sikeresen hozzáadva",
        "ERROR_MESSAGE": "Nem lehet létrehozni a makrót. Kérlek, próbáld újra később"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Név",
        "CREATED BY": "Létrehozta",
        "LAST_UPDATED_BY": "Utoljára szerkesztette:",
        "VISIBILITY": "Láthatóság"
      },
      "404": "Nem találtunk makrót"
    },
    "DELETE": {
      "TOOLTIP": "Makró törlése",
      "CONFIRM": {
        "MESSAGE": "Biztos abban, hogy törli ",
        "YES": "Igen, Törlés",
        "NO": "Nem"
      },
      "API": {
        "SUCCESS_MESSAGE": "Makró sikeresen törölve",
        "ERROR_MESSAGE": "Hiba történt a makró törlése közben. Kérlek próbáld újra később"
      }
    },
    "EDIT": {
      "TOOLTIP": "Makró szerkesztése",
      "API": {
        "SUCCESS_MESSAGE": "Makró frissítve",
        "ERROR_MESSAGE": "Nem sikerült frissíteni a makrót, kérlek próbáld újra később"
      }
    },
    "EDITOR": {
      "START_FLOW": "Flow indítása",
      "END_FLOW": "Flow befejezése",
      "LOADING": "Makró betöltése",
      "ADD_BTN_TOOLTIP": "Akció hozzáadása",
      "DELETE_BTN_TOOLTIP": "Akció törlése",
      "VISIBILITY": {
        "LABEL": "Makró láthatósága",
        "GLOBAL": {
          "LABEL": "Nyilvános",
          "DESCRIPTION": "Ez a makró nyilvánosan elérhető minden ügynök számára ebben a fiókban."
        },
        "PERSONAL": {
          "LABEL": "Privát",
          "DESCRIPTION": "Ez a makró privát, csak Te látod és nem lesz elérhető mások számára."
        }
      }
    },
    "EXECUTE": {
      "BUTTON_TOOLTIP": "Futtatás",
      "PREVIEW": "Makró előnézet",
      "EXECUTED_SUCCESSFULLY": "Makró végrehajtása sikeres"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Az attribútumkulcs megadása kötelező",
      "FILTER_OPERATOR_REQUIRED": "A szűrőoperátor megadása kötelező",
      "VALUE_REQUIRED": "Kötelező megadni",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "Az értéknek 0 és 998 között kell lennie",
      "ACTION_PARAMETERS_REQUIRED": "A művelet paramétereinek megadása kötelező",
      "ATLEAST_ONE_CONDITION_REQUIRED": "Legalább egy feltétel megadása kötelező",
      "ATLEAST_ONE_ACTION_REQUIRED": "Legalább egy művelet megadása kötelező",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998"
    },
    "ACTIONS": {
      "ASSIGN_TEAM": "Csapathoz rendelés",
      "ASSIGN_AGENT": "Ügynökhöz rendelés",
      "ADD_LABEL": "Címke hozzáadása",
      "REMOVE_LABEL": "Címke eltávolítása",
      "REMOVE_ASSIGNED_TEAM": "Hozzárendelt csapat eltávolítása",
      "SEND_EMAIL_TRANSCRIPT": "E-mail átirat küldése",
      "MUTE_CONVERSATION": "Beszélgetés némítása",
      "SNOOZE_CONVERSATION": "Beszélgetés halasztása",
      "RESOLVE_CONVERSATION": "Beszélgetés lezárása",
      "SEND_ATTACHMENT": "Melléklet küldése",
      "SEND_MESSAGE": "Üzenet küldése",
      "CHANGE_PRIORITY": "Prioritás módosítása",
      "ADD_PRIVATE_NOTE": "Privát jegyzet hozzáadása",
      "SEND_WEBHOOK_EVENT": "Webhook esemény küldése"
    },
    "ACTION_VALUES": {
      "SELF": "Saját magam"
    }
  }
}
